import flowGeneralHistory from './components/flow-general-history.vue';
var Plugin = {
  install: function install(Vue) {
    Vue.component('s-general-history', flowGeneralHistory);
  }
};
export { flowGeneralHistory as sGeneralHistory };
export default Plugin;


//////////////////
// WEBPACK FOOTER
// ./src/component/flow-general-history/index.js
// module id = 1
// module chunks = 0